export default "__VITE_ASSET__DWQn3kPI__"